export default __webpack_public_path__ + "static/media/right-calendar-icon.e7e4516a.svg";